import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ToastMessage from './toast-message';
import useAuth from '../../auth/use-auth';
import { SnackbarContext } from '../../context/SnanckarContext';

export default function ToastMessageWrapper() {
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();
    const { snackbarContext, setSnackbarContext } = useContext(SnackbarContext);
    const callback = () => {
        snackbarContext.callback && snackbarContext.callback();
        setSnackbarContext({ open: false });
    };
    return (
        <ToastMessage
            {...snackbarContext}
            fullWidth={!isAuthenticated}
            callback={snackbarContext.callback ? callback : undefined}
            onClose={() => {
                setSnackbarContext({ open: false });
                snackbarContext.onClose && snackbarContext.onClose();
            }}
        >
            {typeof snackbarContext.message === 'string'
                ? t(snackbarContext.message)
                : snackbarContext.message}
        </ToastMessage>
    );
}
